import * as React from 'react';
import { IconProps } from '../../dto/Interfaces/IIconProps';

const ConfirmationEmailCircle: React.FC<IconProps> = () => {
  return (
    <svg width="150" height="151" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M75 150.65c41.421 0 75-33.579 75-75 0-41.422-33.579-75-75-75s-75 33.578-75 75c0 41.421 33.579 75 75 75Z" fill="#EAECF0" />
      <mask id="b" maskUnits="userSpaceOnUse" x="0" y="0" width="150" height="151">
        <path d="M75 150.65c41.421 0 75-33.579 75-75 0-41.422-33.579-75-75-75s-75 33.578-75 75c0 41.421 33.579 75 75 75Z" fill="url(#a)" />
      </mask>
      <g mask="url(#b)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17 87.69a20 20 0 0 1 6.482-14.74L66.606 33.4c5.44-4.989 13.82-4.896 19.15.212l41.083 39.378A19.998 19.998 0 0 1 133 87.43v55.79c0 8.284-6.716 15-15 15H32c-8.284 0-15-6.716-15-15V87.69Z"
          fill="#C7CED4"
        />
        <g filter="url(#c)">
          <rect x="25.27" y="37.582" width="99.46" height="96.303" rx="4" fill="#fff" />
        </g>
        <mask id="d" maskUnits="userSpaceOnUse" x="17" y="29" width="116" height="130">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17 87.69a20 20 0 0 1 6.482-14.74l43.124-39.549c5.44-4.99 13.82-4.898 19.15.21l41.083 39.38A19.998 19.998 0 0 1 133 87.428v55.79c0 8.284-6.716 15-15 15H32c-8.284 0-15-6.716-15-15V87.69Z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#d)">
          <g filter="url(#e)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="m17 78.895 52.154 37.581a10 10 0 0 0 11.692 0L133 78.895v69.324c0 5.522-4.477 10-10 10H27c-5.523 0-10-4.478-10-10V78.895Z"
              fill="#FDFEFF"
            />
          </g>
          <g filter="url(#f)">
            <path fillRule="evenodd" clipRule="evenodd" d="M69.154 120.637a10 10 0 0 1 11.692 0L133 158.219H17l52.154-37.582Z" fill="#fff" />
          </g>
        </g>
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M75 92.799a19.2 19.2 0 1 0 0-38.4 19.2 19.2 0 0 0 0 38.4Zm8.897-22.303a2.4 2.4 0 0 0-3.394-3.394L72.6 75.005l-3.103-3.103a2.4 2.4 0 0 0-3.394 3.394l4.8 4.8a2.4 2.4 0 0 0 3.394 0l9.6-9.6Z"
        fill="#000"
      />
      <defs>
        <filter id="c" x="17.27" y="36.582" width="115.46" height="112.303" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feMorphology radius="4" in="SourceAlpha" result="effect1_dropShadow_9577_33401" />
          <feOffset dy="7" />
          <feGaussianBlur stdDeviation="6" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_9577_33401" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_9577_33401" result="shape" />
        </filter>
        <filter id="e" x="0" y="58.895" width="150" height="113.324" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="-3" />
          <feGaussianBlur stdDeviation="8.5" />
          <feColorMatrix values="0 0 0 0 0.108708 0 0 0 0 0.237823 0 0 0 0 0.391768 0 0 0 0.0690104 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_9577_33401" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_9577_33401" result="shape" />
        </filter>
        <filter id="f" x="10" y="108.75" width="130" height="53.469" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset dy="-3" />
          <feGaussianBlur stdDeviation="3.5" />
          <feColorMatrix values="0 0 0 0 0.252325 0 0 0 0 0.423517 0 0 0 0 0.627631 0 0 0 0.02607 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_9577_33401" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_9577_33401" result="shape" />
        </filter>
        <linearGradient id="a" x1="75" y1=".65" x2="75" y2="150.65" gradientUnits="userSpaceOnUse">
          <stop stopColor="#E3ECFA" />
          <stop offset="1" stopColor="#DAE7FF" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default ConfirmationEmailCircle;
